<ng-container *ngIf="debug$ | async">
  <pre>contentFilter: {{ contentFilter | json }}</pre>
  <hr />
  <pre>{{ debugInfo | json }}</pre>
</ng-container>
<section class="filter-cleaning" [class.mobile]="deviceService.isMobile()">
  <div class="title-wrap">
    <p class="title">{{ 'library.filter-cleaning.title' | translate }}.</p>
    <p class="subtitle" [innerHTML]="'library.filter-cleaning.subtitle' | translate"></p>
  </div>

  <div class="filters-wrap">
    <ul class="filters">
      <li class="filter-wrap">
        <on-ui-button class="primary outline" [label]="'library.filter-cleaning.clean-all'"
                      (onclick)="onCleanAllFilters()">
        </on-ui-button>
      </li>
    </ul>
  </div>
</section>
<section *ngFor="let pane of additionalPanes; trackBy: trackByFn">
  <app-pane [item]="pane"></app-pane>
</section>
